import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect, withRouter } from 'react-router-dom'
import SteamRedirect from '../../containers/SteamRedirect/SteamRedirect'

const PublicOnlyRoute = ({
  user,
  validSession,
  component,
  path,
  name,
  exact,
  strict,
  oauth,
  promotionName,
}) => {
  const routeProps = { path, component, name, exact, strict }

  if (oauth) {
    // Rendering SteamRedirect & passing User to block not auth users
    return <Route path={path} render={props => <SteamRedirect {...props} authUser={user} />} />
  }

  if (user && validSession) {
    return <Redirect to="/claim-reward" />
  }
  return <Route {...routeProps} />
}

const mapStateToProps = state => ({
  user: state.userReducers.currentUser,
  validSession: state.userReducers.validSession,
  promotionName: state.specialPromotionReducer.promotionName,
})

export default withRouter(connect(mapStateToProps)(PublicOnlyRoute))
